import React from "react";
import Carousel from "react-material-ui-carousel";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Card, Paper } from "@mui/material";
//images
import AI from "../assets/1398313.png";
import SOLAR from "../assets/solar-835894_1920.jpg";
function Suggestions(props) {
  var items = [
    {
      image: AI,
      category: "Technology",
      title: "Artificial Intelligence",
      preview:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laboriosa fuga omnis eaque vel numquam illum accusantium possimus non, incidunt pariatur facere consectetur accusamus tempora iure sit ea ipsum dolor sit, amet consectetur adipisicing elit. Laboriosa fuga omnis eaque vel numquam illum accusantium possimus non, incidunt pariatur facere consectetur accusamus tempora iure sit ea",
    },
    {
      image: SOLAR,
      category: "Sustainability",
      title: "Solar Power",
      preview:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laboriosa fuga omnis eaque vel numquam illum accusantium possimus non, incidunt pariatur facere consectetur accusamus tempora iure sit ea ipsum dolor sit, amet consectetur adipisicing elit. Laboriosa fuga omnis eaque vel numquam illum accusantium possimus non, incidunt pariatur facere consectetur accusamus tempora iure sit ea",
    },
  ];
  return (
    <section className="custom-suggestion-section">
      <h2>Suggestions</h2>
      <Carousel
        className="custom-carousel"
        // NextIcon={<ArrowForwardIosIcon />}
        // PrevIcon={<ArrowBackIosNewIcon />}
        next={(next, active) =>
          console.log(`we left ${active}, and are now at ${next}`)
        }
        prev={(prev, active) =>
          console.log(`we left ${active}, and are now at ${prev}`)
        }
      >
        {items.map((item, i) => (
          <Paper className="custom-carousel-card" key={i} elevation={16}>
            <img src={item.image} alt="" />
            <div className="d-flex flex-column p-5">
              <span>{item.category}</span>
              <h1>{item.title}</h1>
              <p>{item.preview}</p>
              <a href="#">See More</a>
            </div>
          </Paper>
        ))}
      </Carousel>
    </section>
  );
}
export default Suggestions;
